<span class="date">{{ today | localizedDate: "EEEE, d 'de' MMMM" }}</span>
<div class="custom-header">
	<button
		mat-button
		type="button"
		class="mat-calendar-period-button"
		(click)="currentPeriodClicked()"
		[attr.aria-label]="periodButtonLabel"
		cdkAriaLive="polite"
	>
		{{ periodButtonText }}
		<div
			class="mat-calendar-arrow"
			[class.mat-calendar-invert]="_calendar.currentView !== 'month'"
		></div>
	</button>

	<button mat-icon-button (click)="previousClicked()">
		<lucide-icon name="chevron-left" class="menu-text"></lucide-icon>
	</button>
	<button mat-icon-button (click)="nextClicked()">
		<lucide-icon name="chevron-right" class="menu-text"></lucide-icon>
	</button>
</div>
